export default __webpack_public_path__ + "static/media/mechanical_keyboard.31d516bb.jpg";